const UUID_RE =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

export function isReportAgentRef(value: string | null | undefined): boolean {
  const s = (value ?? '').trim();
  return UUID_RE.test(s) || /^\d+$/.test(s);
}

export function reportDetailPath(row: { agent_uuid?: string | null }): string[] | null {
  const uuid = (row?.agent_uuid ?? '').trim();
  return isReportAgentRef(uuid) ? ['/reports', uuid] : null;
}

export interface ReportListFilterQuery {
  date_from?: string;
  date_to?: string;
}

export function reportDetailQueryParams(filters: ReportListFilterQuery): Record<string, string> {
  const q: Record<string, string> = {};
  if (filters.date_from) q['date_from'] = filters.date_from;
  if (filters.date_to) q['date_to'] = filters.date_to;
  return q;
}
